var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktokIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107.217,
    height: 107.254,
    viewBox: "0 0 107.217 107.254",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tiktok_black",
    "data-name": "tiktok black",
    transform: "translate(53.608 53.627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artwork_13",
    "data-name": "Artwork 13",
    transform: "translate(-53.608 -53.627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10078",
    "data-name": "Group 10078"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10077",
    "data-name": "Group 10077"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27157",
    "data-name": "Path 27157",
    d: "M107.217,50.269v6.7c-.086.688-.182,1.374-.256,2.063a53.77,53.77,0,0,1-44.036,47.387c-1.981.36-3.992.558-5.989.83h-6.7c-.686-.086-1.372-.18-2.059-.255A52.15,52.15,0,0,1,18.44,94.063C4.752,81.855-1.347,66.482.249,48.23A50.839,50.839,0,0,1,13.392,18.164,52.5,52.5,0,0,1,52.684.017,50.892,50.892,0,0,1,81.1,7.608c13.816,8.5,22.314,20.768,25.293,36.768C106.756,46.324,106.947,48.3,107.217,50.269ZM54.986,23.053V24.5q-.008,19.9-.02,39.795c0,.627-.019,1.258-.079,1.882a9.065,9.065,0,0,1-18.019.192,8.89,8.89,0,0,1,6.83-9.788,24.539,24.539,0,0,1,4.975-.054V46.28a56.449,56.449,0,0,0-6.314.421A18.893,18.893,0,0,0,27.052,69.076,19.208,19.208,0,0,0,50.431,83.7a19.006,19.006,0,0,0,14.614-18.71c.005-6.877-.044-13.754-.069-20.63,0-.37,0-.74,0-1.323a25.418,25.418,0,0,0,15.414,5.207V38.355a15.618,15.618,0,0,1-15.451-15.3Z",
    transform: "translate(0 0)",
    fill: "#e7f0f4"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktok_icon.b871720059cf0f67f86a852ab3c3cc27.svg";
export { ForwardRef as ReactComponent };